import styled from 'styled-components'

export const ProgressIndicatorContainer = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;

	padding-bottom: 5rem;
`
